import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { CreditReport } from "types/landlord/reports";
import { formatToCurrency } from "utils/currency";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

type TrdPartyCollectionDetailsProps = {
  collections?: CreditReport["collections"];
  isNoHit: boolean;
};

export const TrdPartyCollectionDetails = ({
  collections,
  isNoHit
}: TrdPartyCollectionDetailsProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Third party collection details">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Third party collection details">
      {collections?.length ? (
        <>
          {collections.map((collection, index) => (
            <div
              className="flex w-full gap-4"
              key={`credit-report-bankrupcy-${index}`}
            >
              <div className="w-full">
                <div className="h-7 w-full border-b border-alpha-40 flex gap-2 items-center">
                  <p className="test-sm font-bold text-content-1000">
                    Collection {index + 1}
                  </p>
                  {collection.creditor_classification?.description ===
                    "RENTAL/LEASING" && (
                    <Badge variant={BadgeVariant.WARNING} size={BadgeSize.SM}>
                      Rental
                    </Badge>
                  )}
                </div>
                <div className="mt-4 flex w-full mb-4">
                  <div className="flex w-full flex-col gap-3">
                    <Row
                      title="Balance"
                      value={
                        collection.balance
                          ? formatToCurrency(collection.balance)
                          : null
                      }
                    />
                    <Row
                      title="Industry Code"
                      value={collection.industry_code}
                    />
                    <Row
                      title="Customer Number"
                      value={collection.customer_number}
                    />
                    <Row
                      title="Account Number"
                      value={collection.account_number}
                    />
                    <Row title="Client Name" value={collection.client_name} />
                    <Row
                      title="Narrative Codes"
                      value={collection.narrative_codes
                        ?.map((nc) => nc.code)
                        .join(",")}
                    />
                    <Row
                      title="Status"
                      value={collection.status?.description}
                    />
                    <Row
                      title="Date Reported"
                      value={collection.date_reported}
                    />
                    <Row
                      title="Original Amount"
                      value={
                        collection.original_amount
                          ? formatToCurrency(collection.original_amount)
                          : null
                      }
                    />
                  </div>
                  <div className="flex w-full flex-col gap-3">
                    <Row
                      title="Creditor classification code"
                      value={collection.creditor_classification?.code}
                    />
                    <Row
                      title="Creditor classification description"
                      value={collection.creditor_classification?.description}
                    />
                    <Row
                      title="Account designator code"
                      value={collection.account_designator?.code}
                    />
                    <Row
                      title="Account designator description"
                      value={collection.account_designator?.description}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="text-base font-medium">No data available</div>
      )}
    </Section>
  );
};
